// src/api/apiBanks.js
import axios from "../utils/axios";

/// Get Banks
export const getAllBanks = async (page = 1, perPage = 15, filters = {}) => {
    const params = { ...filters };

    if (page) params.page = page;
    if (perPage) params.per_page = perPage;

    const { data } = await axios.get("banks", { params });
    return data;
};

/// Get Banks For Select
export const getBanksForSelect = async () => {
    const { data } = await axios.get("banks/for-select");
    return data;
};

/// Get Bank
export const getBank = async (id) => {
    if (!id) return null;

    const { data } = await axios.get(`banks/${id}`);
    return data;
};

/// Create Bank
export const createBank = async (req) => {
    try {
        const { data } = await axios.post("banks", req, {
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("createBank error:", error);
        throw error;
    }
};

/// Update Bank
export const updateBank = async (req, id) => {
    try {
        const { data } = await axios.put(`banks/${id}`, req, {
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("updateBank error:", error);
        throw error;
    }
};

/// Delete Bank
export const deleteBank = async (id) => {
    try {
        const { data } = await axios.delete(`banks/${id}`, {
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("deleteBank error:", error);
        throw error;
    }
};

/// Delete All Banks
export const deleteAllBanks = async (ids = []) => {
    try {
        const { data } = await axios.delete(
            "banks/mass-destroy",
            { data: { items: ids } },
            { headers: { Accept: "application/json" } }
        );
        return data;
    } catch (error) {
        console.error("deleteAllBanks error:", error);
        throw error;
    }
};

/// Restore Bank
export const restoreBank = async (id) => {
    try {
        const { data } = await axios.post(`banks/${id}/restore`, {}, {
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("restoreBank error:", error);
        throw error;
    }
};

/// Restore multiple Banks
export const restoreAllBanks = async (ids = []) => {
    try {
        const { data } = await axios.post(
            "banks/mass-restore",
            { items: ids },
            {
                headers: { Accept: "application/json" },
            }
        );
        return data;
    } catch (error) {
        console.error("restoreAllBanks error:", error);
        throw error;
    }
};

/// Force Delete Bank
export const forceDeleteBank = async (id) => {
    try {
        const { data } = await axios.delete(`banks/${id}/force-delete`, {
            headers: { Accept: "application/json" },
        });
        return data;
    } catch (error) {
        console.error("forceDeleteBank error:", error);
        throw error;
    }
};

/// Force Delete multiple Banks
export const forceDeleteAllBanks = async (ids = []) => {
    try {
        const { data } = await axios.delete(
            "banks/mass-force-delete",
            { data: { items: ids } },
            {
                headers: { Accept: "application/json" },
            }
        );
        return data;
    } catch (error) {
        console.error("forceDeleteAllBanks error:", error);
        throw error;
    }
};
